module.exports = __webpack_public_path__ + "img/40_69_011_720.e5b1d604.jpg";